<style scoped>
#dotwatch {
   color: #1381c9;
   text-decoration-line: underline;
}
</style>

<template>
  <v-app-bar app hide-on-scroll align-center>
    <v-spacer/>
      <v-app-bar-nav-icon
      href="/"
      >
        <v-img
          :src="require('../assets/icon.png')"
          width="25"
          height="25"
          alt="icon"
          eager
          contain
        ></v-img>
      </v-app-bar-nav-icon>
      <span id="titletext">
        <strong> reddit<span id="dotwatch">.watch</span> </strong> — Download Reddit Videos
      </span>
    <v-spacer/>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
